/**
 * Impede que a roda do mouse altere o valor de um <input type="number">.
 *
 * O navegador incrementa/decrementa o campo numerico focado quando a roda gira
 * sobre ele. No cadastro de meta isso muda bonus, meta, percentual e piso sem o
 * usuario perceber — o cursor passa por cima de um campo recem-preenchido, ele
 * rola a pagina, e o valor anda sozinho. E dinheiro mudando por acidente.
 *
 * Instalado uma vez, no main.js, em vez de campo a campo: so a pasta PublicoMeta
 * tem mais de 50 inputs numericos, e qualquer tela nova herdaria o problema.
 *
 * COMO FUNCIONA
 *
 * Ao focar um campo numerico, um listener de wheel e anexado AO CAMPO; ao sair,
 * removido. Enquanto focado, a roda sobre ele:
 *   1. preventDefault()  impede o navegador de mexer no valor;
 *   2. blur()            tira o foco, para que o PROXIMO giro role a pagina
 *                        normalmente, em vez de ficar preso.
 *
 * POR QUE NAO SO O blur(), que foi a primeira tentativa: quando o handler roda,
 * o navegador ja decidiu a acao padrao do evento, e o valor mudava mesmo com o
 * campo perdendo o foco em seguida. Só preventDefault garante — e ele exige
 * passive: false, senao o navegador o ignora.
 *
 * POR QUE ANEXAR AO CAMPO em vez de escutar o documento: no documento seria
 * preciso adivinhar, pelo alvo do evento, se a roda estava sobre o campo focado.
 * Com Vuetify o alvo pode ser um wrapper, e o palpite erra. Anexado ao campo,
 * o listener so existe quando ha o que proteger.
 *
 * EFEITO COLATERAL ACEITO: o blur dispara os @blur do campo, entao validacao
 * "ao sair" pode aparecer mais cedo. O usuario focou o campo de fato, entao
 * trata-lo como visitado esta correto.
 */

/**
 * @param {EventTarget|null} el
 * @returns {boolean}
 */
export function ehCampoNumerico(el) {
  if (!el || el.tagName !== "INPUT") return false;
  return String(el.type || "").toLowerCase() === "number";
}

/**
 * Bloqueia a roda no campo e devolve o foco ao documento.
 * Exportado para teste; nao ha razao de chamar de fora.
 * @param {WheelEvent} evento
 */
export function bloquearRoda(evento) {
  evento.preventDefault();
  if (evento.currentTarget && evento.currentTarget.blur) evento.currentTarget.blur();
}

/**
 * Registra os listeners. Chamado uma vez, na inicializacao.
 *
 * focusin/focusout e nao focus/blur: os primeiros sobem na arvore e podem ser
 * escutados no documento; os outros nao.
 * @param {Document} doc
 */
export default function travarScrollNumerico(doc = document) {
  doc.addEventListener("focusin", evento => {
    if (ehCampoNumerico(evento.target)) {
      // passive: false e obrigatorio — sem isso o navegador ignora o
      // preventDefault e o valor volta a mudar.
      evento.target.addEventListener("wheel", bloquearRoda, { passive: false });
    }
  });

  doc.addEventListener("focusout", evento => {
    if (ehCampoNumerico(evento.target)) {
      evento.target.removeEventListener("wheel", bloquearRoda);
    }
  });
}
